import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { AccountIssue } from "@/components/Commons/ErrorBanner/AccountIssue";
import { StepBodyStyledText } from "@/components/Commons/StepBodyStyledText";
import { ITS_LIGHT_TEAL, STEP_ID } from "@/components/constants";
import { AppContext } from "@/stores/appStore";
import { ActionType } from "@/stores/constants";

/**
 * Step of showing the Amazon alias that was assigned to the NH.
 */
export default function AmazonUsername(): JSX.Element {
  const { state, dispatch } = useContext(AppContext);

  /**
   * Set the refPage to provide context to IT Support should the new hire initiate
   * a chat with support
   */
  useEffect(() => {
    dispatch({
      type: ActionType.SET_CHAT_SUPPORT_REF_PAGE,
      chatSupportRefPage: "ezo-amazon-username",
    });
  }, []);

  useEffect(() => {
    if (state.amazonUsername) {
      dispatch({
        stepId: STEP_ID.AMAZON_USERNAME,
        type: ActionType.SET_NEXT_BTN_STATUS,
        enableNext: true,
      });
    }
  }, [state.amazonUsername]);

  if (!state.amazonUsername) {
    return <AccountIssue refPage="ezo-blocking-error-200" />;
  }

  return (
    <Col rowGap="S400">
      <StepBodyStyledText>
        <Text fontWeight="regular" dataTestId="amazonUsernameInfo">
          <FormattedMessage
            id="amazonUsername-expander-body-info"
            values={{
              emailAddress: (
                <Text fontWeight="bold" display="inline">
                  {`${state.amazonUsername}@amazon.com`}
                </Text>
              ),
            }}
          />
        </Text>
      </StepBodyStyledText>
      <View
        backgroundColor={ITS_LIGHT_TEAL}
        padding="S500"
        dataTestId="amazonUsernameView"
      >
        <Row justifyContent="space-evenly">
          <Text fontWeight="bold">
            <FormattedMessage
              id="amazonUsername-expander-body-username"
              values={{
                username: (
                  <Text display="inline" color="#9F1F65">
                    {state.amazonUsername}
                  </Text>
                ),
              }}
            />
          </Text>
        </Row>
      </View>
    </Col>
  );
}
